import { render } from "./SystemUserChangePasswordView.vue?vue&type=template&id=6e2cfe9c"
import script from "./SystemUserChangePasswordView.vue?vue&type=script&lang=js"
export * from "./SystemUserChangePasswordView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__